import lang from "translations";

const columns = [
  {
    key: "deviceName",
    text: lang.deviceName,
    maxWidth: "max-content",
    custom: true
  },
  {
    key: "deviceImei",
    text: lang.deviceImei,
    maxWidth: "max-content",
    custom: true
  },
  {
    key: "model",
    text: lang.model,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "venueName",
    text: lang.venue,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "location",
    text: lang.location,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "osVersion",
    text: lang.osVersion,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "firmwareVersion",
    text: lang.firmwareVersion,
    maxWidth: "max-content",
    custom: true, 
  },
  {
    key: "softwareVersion",
    text: lang.softwareVersion,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "ghlVersion",
    text: lang.ghlVersion,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "ttbVersion",
    text: lang.ttbVersion,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "userDetails",
    text: lang.userDetails,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "deviceRegisterDateTime",
    text: lang.deviceRegisterDateTime,
    maxWidth: "max-content",
    custom: true,
  },
  {
    key: "deviceLastLocationDateTime",
    text: lang.deviceLastLocationDateTime,
  },
];

export default columns;
